module.exports = __webpack_public_path__ + "static/media/room221.efc03aa4.JPG";